export const getDeliveryGuarantee = (onlineCheckoutPageGuarantee) => {
    // HOLIDAY TEXT
    // For Monday holidays, normal next guarantee is Thu
    // return 'Due to the Memorial Day holiday, only delivery dates placed with 72 hours notice can be guaranteed. Orders placed with delivery dates with less than 72 hours we will try our best to accommodate.';
    // return 'Due to the ___ holiday, only delivery dates placed for _____ __/__ can be guaranteed. Orders placed with delivery dates before __/__ we will try our best to accommodate.';
    if (!onlineCheckoutPageGuarantee) {
        return 'We can honor delivery dates with 3 or more business days notice. For delivery dates with less than 3 business days notice, we will do our best to accommodate your request.';
    }
    if (onlineCheckoutPageGuarantee === '24') {
        if (new Date().getDay() === 0) {
            return 'For orders placed on Sunday, a Monday delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Tuesday delivery is guaranteed.';
        }
        else if (new Date().getDay() === 6) {
            return 'For orders placed on Saturday, a Monday delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Tuesday delivery is guaranteed.';
        }
        else if (new Date().getDay() === 5) {
            return 'Monday delivery is only guaranteed for orders placed before 12pm.';
        }
        else {
            return 'Next day delivery is only guaranteed for orders placed before 12pm.';
        }
    }
    else if (onlineCheckoutPageGuarantee === '48') {
        if (new Date().getDay() === 0) {
            return 'For orders placed on Sunday, a Tuesday or earlier delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Wednesday delivery is guaranteed.';
        }
        else if (new Date().getDay() === 6) {
            return 'For orders placed on Saturday, a Tuesday or earlier delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Wednesday delivery is guaranteed.';
        }
        else {
            return 'We can honor delivery dates with 2 or more business days notice. For delivery dates with less than 2 business days notice we will do our best to accommodate your request.';
        }
    }
    else if (onlineCheckoutPageGuarantee === '72') {
        if (new Date().getDay() === 0) {
            return 'For orders placed on Sunday, a Wednesday or earlier delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Thursday delivery is guaranteed.';
        }
        else if (new Date().getDay() === 6) {
            return 'For orders placed on Saturday, a Wednesday or earlier delivery cannot be guaranteed. We will try our best to accommodate, otherwise a Thursday delivery is guaranteed.';
        }
        else {
            return 'We can honor delivery dates with 3 or more business days notice. For delivery dates with less than 3 business days notice we will do our best to accommodate your request.';
        }
    }
    else {
        return 'We can honor delivery dates with 3 or more business days notice, for delivery dates with less than 3 business days notice we will do our best to accommodate your request.';
    }
};
const newYearsEve = new Date('2026/12/31');
const newYears = new Date('2027/01/01');
const christmasEve = new Date('2026/12/24');
const christmas = new Date('2026/12/25');
const presidentsDay = new Date('2026/02/16');
const memorial = new Date('2026/05/25');
const fourthJuly = new Date('2026/07/03');
const labor = new Date('2026/09/07');
const columbusDay = new Date('2026/10/12');
const thanksgiving = new Date('2025/11/27');
const blackFriday = new Date('2026/11/26');
const goodFriday = new Date('2026/04/03');
const easterObserved = new Date('2026/04/05');
export const disableDeliveryDate = [
    new Date(), // same day delivery
    newYearsEve,
    newYears,
    christmasEve,
    christmas,
    memorial,
    presidentsDay,
    fourthJuly,
    labor,
    columbusDay,
    thanksgiving,
    blackFriday,
    goodFriday,
    easterObserved,
];
//# sourceMappingURL=get-delivery-guarantee.js.map